import { render, staticRenderFns } from "./task-project-table.vue?vue&type=template&id=63a30442&"
import script from "./task-project-table.vue?vue&type=script&lang=js&"
export * from "./task-project-table.vue?vue&type=script&lang=js&"
import style0 from "./task-project-table.vue?vue&type=style&index=0&id=63a30442&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports